export function loadImages(srcs = '') {
  function autoLoadImage(src) {
    if (!src) {
      return
    }
    let img = new Image()
    img.onload = function () {
      img = null
    }
    img.onerror = function () {
      img = null
    }
    img.src = src
  }
  if (typeof imgSrcs === 'string') {
    autoLoadImage(srcs)
  }
  if (srcs && Array.isArray([srcs])) {
    srcs.forEach((node) => autoLoadImage(node))
  }
}

function checkImgExists(imgurl) {
  return new Promise((resolve, reject) => {
    var ImgObj = new Image()
    ImgObj.onload = function (res) {
      ImgObj = null
      resolve(res)
    }
    ImgObj.onerror = function (err) {
      ImgObj = null
      reject(err)
    }
    ImgObj.src = imgurl
  })
}

export async function imgLoadedHandler(targetUrl, defaultImg) {
  const res = await checkImgExists(targetUrl)
    .then(() => {
      return Promise.resolve(encodeURI(targetUrl))
    })
    .catch(() => {
      return Promise.resolve(defaultImg)
    })
  return res
}

export function getImage(targetDir, defaultImgPath) {
  let img = null
  try {
    img = require(`@/assets/images${targetDir}`)
    return img
  } catch (e) {
    img = require(`@/assets/images${defaultImgPath}`)
    return img
  }
}
